import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type BatchUpdateCharacteristicGroupsRequest as SchemaBatchUpdateCharacteristicGroupsRequest } from '../schemas/BatchUpdateCharacteristicGroupsRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Characteristics
 */
export const BatchUpdateCharacteristicGroupsContentType = 'application/json' as const;
export type BatchUpdateCharacteristicGroupsRequest = SchemaBatchUpdateCharacteristicGroupsRequest;
export type BatchUpdateCharacteristicGroupsResponses = LinkCommonErrorResponses & {
    /**
     * @description Display sequences updated successfully
     */
    '200': {};
};
export type BatchUpdateCharacteristicGroupsResponseSuccess = undefined;
export type BatchUpdateCharacteristicGroupsSearchParams = undefined;
export type BatchUpdateCharacteristicGroupsPathParameters = undefined;
export const BatchUpdateCharacteristicGroupsUrl = '/characteristics/groups' as const;
export const BatchUpdateCharacteristicGroupsMethod = 'PATCH' as const;
export const getBatchUpdateCharacteristicGroupsUrl = (_params?: BatchUpdateCharacteristicGroupsPathParameters) =>
    BatchUpdateCharacteristicGroupsUrl;
